const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

type UuidParamKind = 'missing' | 'uuid' | 'malformed';

export const isUuid = (value: string): boolean => UUID_PATTERN.test(value);

export function classifyUuidParam(
  value: string | null | undefined
): UuidParamKind {
  if (!value) return 'missing';
  return isUuid(value) ? 'uuid' : 'malformed';
}
